import TransactionStatus from "enums/TransactionStatus";
import ViolationType from "enums/ViolationType";

/** The parameters /my/transactions applies on arrival and then drops from the address. */
export const MY_TRANSACTIONS_LINK_PARAMS = ["tab", "status", "compliance"];

export interface MyTransactionsLink {
  tab?: "task";
  statuses?: readonly TransactionStatus[];
  compliance?: ViolationType;
}

/** A link into /my/transactions with its tab and filters preselected. */
export const myTransactionsLink = ({
  tab,
  statuses,
  compliance,
}: MyTransactionsLink = {}): string => {
  const params = new URLSearchParams();
  if (tab) params.set("tab", tab);
  if (statuses?.length) params.set("status", statuses.join(","));
  if (compliance) params.set("compliance", compliance);
  const search = params.toString();
  return `/my/transactions${search ? `?${search}` : ""}`;
};

/** What a link asked /my/transactions to preselect, unvalidated: the page keeps only what it offers. */
export const readMyTransactionsLink = (params: URLSearchParams) => ({
  tab: params.get("tab"),
  statuses: params.get("status")?.split(",").filter(Boolean) ?? [],
  compliance: params.get("compliance"),
});
